import React, { useState, Key } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { PaginationProps } from "antd/es/pagination";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from "@/utils/constants";
import { IPgProps, ISearchPage } from "@/types/ScmTypes";
import { globalPrompt } from "@/components/message";
import { convertRes2Blob } from "@/utils/exportFile";
import { transPgToPagination } from "@/utils/utils";
import { technicianService } from "./technicianService";
import { ITechnicianSearch, ITechnicianDetail, ITechnicianFields } from "./technicianType"
import { useGlobalModel } from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";
export const useTechnicianModel = createModel(function () {
    const { user, setTechniciankData,setLocale } = useGlobalModel();
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const Locale = setLocale(LanguageArr)
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    //列表数据
    const [dataSource, setDataSource] = useState<ITechnicianDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<ITechnicianFields>({});
    //分页参数
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格选中id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<Key[]>([]);
    //表格选中行的值
    const [selectedRow, setSelectedRow] = useState<ITechnicianDetail[]>([]);

    //编辑表单缓存
    const [editFormVal, setEditFormVal] = useState<ITechnicianFields>({});
    //新增表单缓存
    const [addFormVal, setAddFormVal] = useState<ITechnicianFields>({});
    //弹框显示控制
    const [detailDrawer, setDetailDrawer] = useState<boolean>(false)
    //弹框状态值
    const [detailType, setDetailType] = useState<string>("");
    //设置搜索value
    const updateSearchParam = (updateParam: ITechnicianFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    //所有列表查询
    const loadTechnician = async () => {
        const params = {
            pageSize: 10000,
            pageNum: 1
        }
        let { retData } = await technicianService.page(params);
        const { records, ...pg } = retData;
        let newRecords = records.map(item => {
            return {
                ...item,
                code: item.technicianCode
            }
        })
        setTechniciankData(newRecords)
    }
    //列表查询
    const loadData = async (page?: ISearchPage, searchValue: ITechnicianFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current)?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await technicianService.page(searchParams);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
    }
    //表单新增修改
    const updateAddFormVal = (val: ITechnicianFields) => {
        let newVal = val
        Object.keys(val).length !== 0 ? setAddFormVal({ ...addFormVal, ...newVal }) : setAddFormVal({});
    }
    //表单新增修改
    const updateEditFormVal = (val: ITechnicianFields) => {
        let newVal = val
        Object.keys(val).length !== 0 ? setEditFormVal({ ...editFormVal, ...newVal }) : setEditFormVal({});
    }
    //表单新增 Api
    const insertDetail = async (data: ITechnicianFields) => {
        let { retData } = await technicianService.insert(data);
        retData ?
            // loadData() && globalPrompt("message", { text: "维修技师新增成功", type: "success" })
            // : globalPrompt("message", { text: "维修技师新增失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully added"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully added"], type: "error" });            
        return retData;
    }

    //表单编辑 Api
    const editDetail = async (data: ITechnicianFields) => {
        let { retData } = await technicianService.update(data);
        retData ?
            // loadData() && globalPrompt("message", { text: "维修技师编辑成功", type: "success" })
            // : globalPrompt("message", { text: "维修技师编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });            
        return retData;
    }
    const onDisabled = async (id: string, checked: boolean) => {
        let params = {
            id,
            enable: checked ? 1 : 0
        }
        let { retData } = await technicianService.disable(params)
        retData ?
            // loadData() && globalPrompt("message", { text: "维修技师编辑成功", type: "success" })
            // : globalPrompt("message", { text: "维修技师编辑失败", type: "error" });
            loadData() && globalPrompt("message", { text: Locale["Successfully edited"], type: "success" })
            : globalPrompt("message", { text: Locale["Unsuccessfully edited"], type: "error" });
        return retData;
    }

    return {
        dataSource,
        searchParam,
        pgCfg,
        selectedRowKeys,
        addFormVal,
        editFormVal,
        detailDrawer,
        detailType,
        selectedRow,
        setAddFormVal,
        setSelectedRowKeys,
        setPgCfg,
        setSearchParam,
        setDataSource,
        updateSearchParam,
        resetSearchParam,
        loadData,
        updateAddFormVal,
        updateEditFormVal,
        insertDetail,
        editDetail,
        setDetailDrawer,
        setDetailType,
        setSelectedRow,
        onDisabled,
        loadTechnician
    }
})